export const labels = {
	save: {
		cancel: {
			label: "Label.MobileCreator.Save.Cancel",
			default: "Don't save",
		},
		save: {
			label: "Label.MobileCreator.Save.Save",
			default: "Save",
		},
		title: {
			label: "Label.MobileCreator.Save.Title",
			default: "Save your product",
		},
		message: {
			// description: "Message in save product dialog",
			label: "Label.MobileCreator.Save.Message",
			default: "Enter a name for your product to be saved on your account.",
		},
		name: {
			// description: `Used as label in front of a text input (product name) field
			// in save product dialog.`,
			label: "Label.MobileCreator.Save.Name",
			default: "Enter a name for your product",
		},
		error: {
			// description: A human friendly error message shown in an alert dialog when save failed
			label: "Label.MobileCreator.Save.Error",
			default: "An error happened while saving your project. Try later again.",
		},
	},
	leave: {
		cancel: {
			label: "Label.MobileCreator.SaveLeave.Cancel",
			default: "Leave without saving",
		},
		save: {
			label: "Label.MobileCreator.SaveLeave.Save",
			default: "Save",
		},
		title: {
			label: "Label.MobileCreator.SaveLeave.Title",
			default: "Save your product before leaving",
		},
		message: {
			// description: "Message in save product dialog when user is trying to leave editor",
			label: "Label.MobileCreator.SaveLeave.Message",
			default: "Enter a name for you product to be saved on your account.",
		},
	},
};
